import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom';
import { Row, Col, Divider } from 'antd'
import './ImpressaoPedido.scss';
import { Estoque, Dinheiro } from '..';
import {  useAxios } from '../../hooks';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { usePedido } from '../../services/usePedidos';



const Vendedor = ({pedido}) => {
    

    if(pedido.vendedor && pedido.vendedor !== null){
        return (
            <Col span={3} className="dados vendedor">
                                
                <h1>Vendedor</h1>
                <h2>{pedido.vendedor.nome}</h2>
            </Col>
        )
    } 

    return (<Col span={8} className="dados vendedor">            
                <h1>Vendedor</h1>
                <h2>N/D</h2>
            </Col>);
}

const Cliente = ({pedido}) => {

    const contato = (cliente) => {
        if(cliente.telefone || cliente.email){
            return (<>
                        <span className="label">CONTATO</span>
                        <span>{cliente.telefone}</span>
                        <span>{cliente.email}</span>
                   </>)
        }
        return <></>;
    }

    

    if(pedido.cliente){
        const cliente = pedido.cliente;
        const cpfCnpj = cliente.documento? cliente.documento.cpfCnpj : '';
        return (<>
                <Row className='form'>
                    
                    <Col span={6} className={["dados", "cliente"]}>
                        <h1>Dados do Cliente</h1>
                        <h2>{cliente.nome}</h2>
                        <span>{cpfCnpj}</span>
                    </Col>
                   

                    <Col span={6} className={["dados", "cliente"]}>
                        {contato(cliente)}
                    </Col>

                    <Col span={6} className={["dados", "cliente"]}>
                        <h1>Endereço</h1>
                        {/* <span className="label">ENDEREÇO</span> */}
                        <span>{cliente.endereco || ''} {cliente.numero || 'S/N'}. {cliente.bairro || ''}</span>
                        {/* <span></span> */}
                        <span>{cliente.complemento || ''}</span>
                        <span>
                            {
                                (() => {
                                    const cep = cliente.cep || '';
                                    const cidade = (cliente.cidade)? cliente.cidade.cidade || '' : '';
                                    const estado = (cliente.estado)? cliente.estado.uf || '' : '';

                                    let escrita = ``;
                                    if(cep){
                                        escrita += cep + ' ';
                                    }
                                    if(cidade){
                                        escrita += cidade + ' ';

                                        if(estado){
                                            escrita +=  '- ' + estado;
                                        }
                                    }
                                    return  escrita
                                
                                })()
                            }
                           </span>
                    </Col>
                    <Col>
                        <Vendedor pedido={pedido}></Vendedor>
                    </Col>

                    
                              
                </Row>
                </>
            )
    }
    return <>
         <Row className='form'>
                    
            <Col span={12} className={["dados", "cliente"]}>
                <h1>Dados do Cliente</h1>
                <h2>N/D</h2>                
            </Col>

            <Vendedor pedido={pedido}></Vendedor>
                        
        </Row>
    </>;
}

const CabecalhoItens = () => {
    return <Row className="cabecalhoItens">
        <Col span={5}>
            CÓDIGO
        </Col>
        <Col span={8}>
            DESCRIÇÃO
        </Col>
        <Col span={5} className="valores">
            QTD x VL UNITARIO
        </Col>

        <Col span={3} className="valores">
             DESCONTOS
        </Col>
        <Col span={3} className="valores">
             TOTAL ITEM
        </Col>
    </Row>

}


const CabecalhoServicos = () => {
    return <Row className="cabecalhoItens">
        <Col span={13}>
            DESCRIÇÃO
        </Col>
        <Col span={5} className="valores">
            QTD x VL UNITARIO
        </Col>

        <Col span={3} className="valores">
             DESCONTOS
        </Col>
        <Col span={3} className="valores">
             TOTAL Servico
        </Col>
    </Row>

}

const Item = ({item}) => {
    return <Row className="item">
        <Col span={5}>
            {item.codigoProduto}
        </Col>
        <Col span={8}>
            {item.descricaoProduto}
        </Col>
        <Col span={5} className="valores">
            <Estoque value={item.quantidade} unMedida={(item && item.unidade) || "UN"}></Estoque>x <Dinheiro value={item.valorUn} decimalScale={4}></Dinheiro>
        </Col>

        <Col span={3} className="valores">
             (<Dinheiro value={item.totalDescontos}></Dinheiro>)
        </Col>
        <Col span={3} className="valores">
             <Dinheiro value={item.totalItem}></Dinheiro>
        </Col>
    </Row>
}


const ItemServico = ({item}) => {
    return <Row className="item">
       
        <Col span={13}>
            {item.descricaoServico}
        </Col>
        <Col span={5} className="valores">
            <Estoque value={item.quantidade} unMedida={"UN"}></Estoque>x <Dinheiro value={item.valorUn} decimalScale={4}></Dinheiro>
        </Col>

        <Col span={3} className="valores">
             (<Dinheiro value={item.totalDescontos}></Dinheiro>)
        </Col>
        <Col span={3} className="valores">
             <Dinheiro value={item.totalServico}></Dinheiro>
        </Col>
    </Row>
}

const Itens = ({itens}) => {

    if(itens && itens !== null){
       return itens.map((item, index) => {
           const numItem = index + 1;
           if((numItem % 20) == 0){
               return (<Item item={item} key={item.id} className=""></Item>)
           }
           return (<Item  key={item.id} item={item}></Item>)
        });
        
    }
    return <></>
}   


const ItensServico = ({itens}) => {

    if(itens && itens !== null){
       return itens.map((item, index) => {
           const numItem = index + 1;
           if((numItem % 20) == 0){
               return (<ItemServico item={item} className=""></ItemServico>)
           }
           return (<ItemServico item={item}></ItemServico>)
        });
        
    }
    return <></>
}   

const Produtos = ({pedido}) => {
    const cabecalho = () => {
        return (
        <>
            <Divider orientation="left" className="dividerProdutos"></Divider>
            <Row className='form'>
                <Col span={24} className="dados">
                    <h1>Produtos</h1>
                </Col>
            </Row>
        </>);
    }

    
    if(pedido && pedido.itens && pedido.itens.length){
        return <>
            {cabecalho()}
            <div className="itens-wrapper">
                <CabecalhoItens></CabecalhoItens>
                <Itens itens={pedido.itens}></Itens>
            </div>
        </>

    } 
    return <></>;
}

const Logotipo = ({logotipo}) => {
    if(logotipo){
        return <Col flex={"3cm"}>
            <span className="logotipo">
                <img 
                    src={logotipo} 
                    alt="logotipo"
                    style={{width: "3cm"}}

                ></img>
            </span>
        </Col>
    }
    return <></>
}
const Empresa = ({empresa}) => {
   
    let nome = empresa?.nomeFantasia || empresa?.razaoSocial || "";
    nome = nome.substr(0, 95);
    if(empresa){
        return ([

                <Logotipo logotipo={empresa.logotipo}></Logotipo>,

                <Col flex={"calc(100% - 7cm)"}>
                
                    <span className="nome" style={{display: "block"}}>{nome}</span>
                    <span className="cnpj" style={{display: "block"}}>{empresa.cnpj}</span>
                    <span className="contato" style={{display: "block"}}>{empresa.telefone} | {empresa.email} </span>
                    <span className="endereco"  style={{display: "block"}}>{empresa.endereco.CEP} - {empresa.endereco.logradouro} {empresa.endereco.nro} {empresa.endereco.complemento}, {empresa.endereco.bairro} - {empresa.endereco.cidade.cidade} {empresa.endereco.estado.uf} </span>
                </Col>
            ])
    } 
    return (<Col span={12}></Col>) 
}

const Observacoes = ({pedido}) => {
    return (<div className="obs-wrapper">
        <Row>
            <Col span={24}>
                <span className="label">Observações</span>
            </Col>
        </Row>
        <Row>
            <Col className='obs'>{pedido.obs || "N/D"}</Col>
        </Row>
    </div>);
    
      
    
}

const Totais = ({pedido}) => {
    if(!pedido){
        return <></>;
    }
    let tituloTotalPedido = "Total Pedido";
    let totalServicos = <></>;
    if(pedido.tipoPedido == "ORDEM_SERVICO"){
        tituloTotalPedido = "Total OS";
        totalServicos = (<Col>
                <span className='label'>Total Servicos</span>
                <span className='valor'><Dinheiro value={pedido.totalServicos} /></span>
            </Col>)
    }
    return (
    <footer  className="total">

        <Row gutter={14}>
            {totalServicos}
            <Col>
                <span className='label'>Total Produtos</span>
                <span className='valor'><Dinheiro value={pedido.totalProdutos} /></span>
            </Col>
            <Col>
                <span className='label'>Total Descontos</span>
                <span className='valor'><Dinheiro value={pedido.totalDescontos} /></span>
            </Col> 

            <Col>
                <span className='label'>{tituloTotalPedido}</span>
                <span className='valor'><Dinheiro value={pedido.totalPedido} /></span>
            </Col>
        </Row>
    </footer>)
}


const Servicos = ({pedido})=>{
    
    const cabecalho = () => {
        return (
        <>
            <Divider orientation="left" className="dividerProdutos"></Divider>
            <Row className='form'>
                <Col span={24} className="dados">
                    <h1>Serviços</h1>
                </Col>
            </Row>
        </>);
    }

    
    if(pedido && pedido.servicos && pedido.servicos.length){
        return <>
            {cabecalho()}
            <div className="itens-wrapper">
                <CabecalhoServicos></CabecalhoServicos>
                <ItensServico itens={pedido.servicos}></ItensServico>
            </div>
        </>

    } 
    return <></>;
    
    //return <>Servicos aqui</>

}

const DescricaoOS = ({pedido, className=""})=>{

    return <Row className={["form", className, "descricaoOS"]}>
        <Col span={24} className="dados">
            <h1>Dados da OS</h1>
            <span>
                {pedido.descricao}
            </span>

        </Col>
    </Row>
}

const ImpressaoPedido = ({pedido}) => {

    const reducerTermosUso = useSelector((state) => state.reducerTermosUso);
    const {buscaTermosUso} = usePedido();
    const {termosUso} = reducerTermosUso;
    const dispatch = useDispatch();
    const {getApiEmitirNotas} = useAxios();
    const [empresa, setEmpresa] = useState();
   
    // useEffect(()=> {
    //     if (pedido && pedido.id && empresa) {
    //         onReady();
    //     }
    // }, [pedido, empresa, onReady]);

    useEffect(()=> {
        defineEmpresa();
    }, [true]);

    useEffect(()=> {
        realizaBuscaTermosUso();
    }, [true]);

    const defineEmpresa = async () => {
        const api = await getApiEmitirNotas();
        const result = await api.get('/empresa');
        setEmpresa(result.data);

    }

    const realizaBuscaTermosUso = async ()=> {
        const termosUso = await buscaTermosUso();
        dispatch({type: "setTermosUso", payload: termosUso} );
    }

    let elementoImpressao = false;
    
    if(pedido.tipoPedido == "ORDEM_SERVICO"){
        if(pedido.status == "ABERTO"){
            elementoImpressao = (<ImpressaoPedidoDuasVias pedido={pedido} empresa={empresa} termosUso={termosUso}></ImpressaoPedidoDuasVias>)
        }
    }

    if(!elementoImpressao){
        elementoImpressao = (<ImpressaoPedidoCompleto empresa={empresa}  pedido={pedido}></ImpressaoPedidoCompleto>)
    }

    // Garante que o elemento #print existe antes de tentar renderizar
    let printElm = document.getElementById('print');
    if (!printElm) {
        printElm = document.createElement('div');
        printElm.id = 'print';
        printElm.className = 'print';
        document.body.appendChild(printElm);
    }
    
    return ReactDOM.createPortal(
        elementoImpressao,
        printElm
    );
}

const ImpressaoPedidoCompleto = ({pedido, empresa}) => {
    let tagServicos = <></>;
    let tagDescricaoOS = <></>;
    let tituloPedido = "PEDIDO";

    if(pedido.tipoPedido == "ORDEM_SERVICO"){
        tagServicos = <Servicos pedido={pedido}></Servicos>;
        tagDescricaoOS = <DescricaoOS pedido={pedido}></DescricaoOS>;
        tituloPedido = "OS";
    }
    return (<div className='wrapperImpressao'>

                <div id='impressaoPedido'>
                
                    <table style={{width: "100%"}}>
                        <thead>
                            <tr>
                                <td>
                                <Row className='cabecalho' id="cabecalhoImpressao">
                                    <Empresa empresa={empresa}></Empresa>
                                    <Col flex={"3cm"}>
                                        <h1><span className={"status"}>{pedido.status}</span> | {tituloPedido} {pedido.numeroPedido}</h1> 
                                        <span className="status">DATA {tituloPedido}: {moment(pedido.dataAbertura).format("DD/MM/YYYY")}</span>
                                        <span className="pageNumber"></span>
                                    </Col>
                                </Row>

                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                
                                    <Cliente pedido={pedido}></Cliente>

                                    {tagDescricaoOS}

                                    <Produtos pedido={pedido}></Produtos>   

                                    {tagServicos}

                                    <Observacoes pedido={pedido}></Observacoes> 
                                </td>
                            </tr>
                        </tbody>
                        <tfoot style={{
                            display: "table-row-group"
                        }}>
                            <tr>
                                <td>
                                    <Totais pedido={pedido}></Totais>          

                                </td>
                            </tr>
                        </tfoot>
                    </table>

                   
                   
                
                    

                </div>
            </div>

    )
};

const TermosDeUso = ({termosUso})=> {
    return <Row className={["form", 'simplificado', 'termosUso']}>
        <Col span={24} className="dados">
            <h1>Condições Gerais</h1>
        </Col>
        <Col span={24} className="termos">
            {termosUso.termos}
        </Col>

    </Row>
};

const Assinatura = () => {
    return <Row>
        <Col>
            <span style={{marginTop: "30px", display: "block"}}>____________________________________________</span>
            <span style={{ display:"block"}}>Li e concordo com as condições Gerais</span>

        </Col>

    </Row>
}


const ParteDaImpressaoPedidoSimplificado = ({pedido, termosUso, empresa})=>{
    let tagServicos = <></>;
    let tagDescricaoOS = <></>;
    let tituloPedido = "PEDIDO";

    if(pedido.tipoPedido == "ORDEM_SERVICO"){
        tagServicos = <Servicos pedido={pedido}></Servicos>;
        tagDescricaoOS = <DescricaoOS pedido={pedido} className="simplificado"></DescricaoOS>;
        tituloPedido = "OS";
    }

    return <>
                <Row className='cabecalho' id="cabecalhoImpressao">
                    <Empresa empresa={empresa}></Empresa>
                    <Col span={12} className={["informacoesPedido"]}>
                        <h1> <span className={"status"}>{pedido.status}</span> | {tituloPedido} {pedido.numeroPedido}</h1> 
                        <span className="status">DATA {tituloPedido}: {moment(pedido.dataAbertura).format("DD/MM/YYYY")}</span>
                    </Col>
                </Row>

                <Cliente pedido={pedido}></Cliente>

                {tagDescricaoOS}

                {/* <Observacoes pedido={pedido}></Observacoes>  */}
                <TermosDeUso termosUso={termosUso}></TermosDeUso>
                <Assinatura></Assinatura>

                    
        </>
}

const Picote = () => {
    return <span style={{
        
        borderTopWidth: '1px',
        borderTopColor: "black",
        backgroundImage: `linear-gradient(to right, black 50%, transparent 50%)`,
        backgroundPosition: `left top`,
        backgroundRepeat: `repeat-x`,
        backgroundSize: `15px 2px`,
        width: "100%",
        display: "block",
        margin: "20px 0 10px 0",
    }}>&nbsp;</span>
}

const ImpressaoPedidoDuasVias = ({pedido, termosUso, empresa}) => {
    
    return (<div className='wrapperImpressao'>
            <div id='impressaoPedido'>
            
                <ParteDaImpressaoPedidoSimplificado pedido={pedido} empresa={empresa} termosUso={termosUso} ></ParteDaImpressaoPedidoSimplificado>
                
                <Picote></Picote>

                <ParteDaImpressaoPedidoSimplificado pedido={pedido} empresa={empresa} termosUso={termosUso} ></ParteDaImpressaoPedidoSimplificado>
            </div>

                
            </div>

    )
};

export {ImpressaoPedido};